import { render, staticRenderFns } from "./button-red.vue?vue&type=template&id=7e57043f"
import script from "./button-red.vue?vue&type=script&lang=js"
export * from "./button-red.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports